import {cloudStorage} from "./firebase-config";
import 'firebase/storage';

const ALBUM = `album`;
const BLOGS = `blog-photos`;

// ==============================================   ALBUM STORAGE    ===================================================
// =====================================================================================================================

export const savePhotoFile = (refId, file) => {
    const fileRef = cloudStorage.ref(`${ALBUM}/${refId}-${file.name}`);
    return fileRef.put(file)
        .then(res => res)
        .catch(err => err)
}

export const deletePhotoFile = (fileName) => {
    return cloudStorage
        .ref(`${ALBUM}/${fileName}`)
        .delete();
}


export const getPhotoUrl = (fileName) => {
    return cloudStorage
        .ref(`${ALBUM}/${fileName}`)
        .getDownloadURL()
        .then(url => url);
}

// ==============================================   BLOG STORAGE    ====================================================
// =====================================================================================================================

export const deleteBlogPhotos = (blogTitle) => {
    const folder = `${BLOGS}/${blogTitle}`;
    return cloudStorage
        .ref(folder)
        .listAll()
        .then(listResults => {
            const promises = listResults.items.map((item) => item.delete());
            return Promise.all(promises);
        });
}

export const saveBlogPicture = (input, title) =>
    new Promise(resolve => {
        const fileRef = cloudStorage.ref(`${BLOGS}/${title}/${input.value.name}`);
        fileRef.put(input.value)
            .then(snapshot => {
                snapshot.ref.getDownloadURL()
                    .then(url => {
                        input.value = url;
                        resolve(input);
                    })
            })
    })
